import { requestApi } from 'api/Api';

export const getCdtCodes = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/get', navigate, params });

export const getCdtWithSpecialties = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/get_with_specialties', navigate, params });

export const createCdtCode = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/create', navigate, params });

export const updateCdtCode = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/update', navigate, params });

export const deleteCdtCode = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/delete', navigate, params });

export const checkExistingCdtCodes = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/check_existing', navigate, params });

export const bulkImportCdtCodes = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/bulk_import', navigate, params });
